import * as React from 'react';
import type { BasketItem, SystemQuote } from "@/types";
import { Button } from "../atoms/button";

type BasketItemsListProps = {
  items: BasketItem[];
  onDelete: (item: BasketItem) => () => void;
  onQtyChange: (item: BasketItem) => (value: number) => void;
  handleViewSystem: (item: SystemQuote) => () => void;
  total: number;
};

function getBasketProduct(item: BasketItem)  {
  return item.itemType === 'System Quote' ? item.item.name : '';
}

function calcSubtotal(item: BasketItem) {
  return (item.sp*item.qty).toLocaleString();
}

export function BasketItemsList(props: BasketItemsListProps) {
  if(props.items && props.items.length > 0) {
    return(
      <div className="flex flex-col gap-4 mt-8 w-full">
        {
          props.items.map((item: BasketItem) => (
            <div className="flex flex-row" key={`__basket-item__${item.item._id}__`}>
              <div className="basis-3/4 flex-none">
                <h3>{getBasketProduct(item)}</h3>
                <Button onClick={props.handleViewSystem(item.item)} variant="link">View</Button>|<Button variant="link" onClick={props.onDelete(item)}>Remove</Button>
              </div>
              <div className="basis-1/4 flex-none text-right">${calcSubtotal(item)}</div>
            </div>
          ))
        }
        <div className="flex flex-row mt-8">
          <div className="basis-3/4 flex-none text-xl font-bold">TOTAL</div>
          <div className="basis-1/4 flex-none text-xl font-bold text-right">${props.total.toLocaleString()}</div>
        </div>
      </div>
    )
  }
  return null;
}
